import { render, staticRenderFns } from "./AstaRuoliCustom.vue?vue&type=template&id=d129aa52&scoped=true&"
import script from "./AstaRuoliCustom.vue?vue&type=script&lang=js&"
export * from "./AstaRuoliCustom.vue?vue&type=script&lang=js&"
import style0 from "./AstaRuoliCustom.vue?vue&type=style&index=0&id=d129aa52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d129aa52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d129aa52')) {
      api.createRecord('d129aa52', component.options)
    } else {
      api.reload('d129aa52', component.options)
    }
    module.hot.accept("./AstaRuoliCustom.vue?vue&type=template&id=d129aa52&scoped=true&", function () {
      api.rerender('d129aa52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaRuoliCustom.vue"
export default component.exports